import React, { useState } from "react";
import { useHistory, Prompt } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import {
	Typography,
	FormControl,
	Select,
	InputLabel,
	MenuItem,
	Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
	},
	submit: {
		margin: theme.spacing(2, 0, 1),
	},
}));

export default function UsersAdd(props) {
	const classes = useStyles();
	const [user, setUser] = useState();
	const [unsaved, setUnsaved] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();

	const onChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
		setUnsaved(true);
	};

	const onSubmit = (e) => {
		e.preventDefault();

		if (user.password !== user.confirmPassword) {
			return enqueueSnackbar("Your passwords do not match. Please try again.", {
				variant: "error",
			});
		}

		fetch(`${process.env.REACT_APP_API_URL}/users`, {
			method: "POST",
			credentials: "include",
			body: JSON.stringify(user),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					setUnsaved(false);
					enqueueSnackbar("User added successfully!", { variant: "success" });
					history.push(`/${process.env.REACT_APP_ADMIN_URL}/users`);
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	return (
		<>
			<Prompt
				when={unsaved}
				message="You have unsaved changes. Are you sure you want to leave?"
			/>
			<Typography component="h1" variant="h4">
				Add a User
			</Typography>
			<form className={classes.form} onSubmit={onSubmit}>
				<Grid container spacing={1}>
					<Grid item sm={6} xs={12}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="name"
							label="Name"
							name="name"
							size="small"
							required
							autoFocus
							onChange={onChange}
						/>
					</Grid>
					<Grid item sm={6} xs={12}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="email"
							label="E-mail"
							name="email"
							size="small"
							type="email"
							required
							onChange={onChange}
						/>
					</Grid>
				</Grid>
				<FormControl
					fullWidth
					size="small"
					margin="normal"
					variant="outlined"
					className={classes.formControl}
					required
					name="role"
				>
					<InputLabel id="user-role-label">Role</InputLabel>
					<Select
						inputProps={{ name: "role" }}
						value={(user && user.role) || ""}
						onChange={onChange}
						label="role"
					>
						<MenuItem value="">
							<em>None</em>
						</MenuItem>
						<MenuItem value="editor">Editor</MenuItem>
						<MenuItem value="admin">Admin</MenuItem>
					</Select>
				</FormControl>
				<Grid container spacing={1}>
					<Grid item sm={6} xs={12}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="password"
							label="Password"
							name="password"
							size="small"
							type="password"
							required
							onChange={onChange}
						/>
					</Grid>
					<Grid item sm={6} xs={12}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="confirmPassword"
							label="Confirm Password"
							name="confirmPassword"
							size="small"
							type="password"
							required
							onChange={onChange}
						/>
					</Grid>
				</Grid>
				<Button
					type="submit"
					fullWidth
					variant="contained"
					color="primary"
					className={classes.submit}
				>
					Save
				</Button>
			</form>
		</>
	);
}
